var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,_vm._b({tag:"element",staticClass:"iv-image"},'element',{
        ..._vm.$attrs,
        ..._vm.$props,
        ...(_vm.tag != 'img'
            ? {
                  style: {
                      'background-image': `url(${_vm.src})`,
                  },
              }
            : {}),
    },false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }